import { render, staticRenderFns } from "./electricityAdjustment.vue?vue&type=template&id=72b56d76&scoped=true"
import script from "./electricityAdjustment.vue?vue&type=script&lang=js"
export * from "./electricityAdjustment.vue?vue&type=script&lang=js"
import style0 from "./electricityAdjustment.vue?vue&type=style&index=0&id=72b56d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b56d76",
  null
  
)

export default component.exports